<script>
import VantActionSheet from 'vant/lib/action-sheet';
import 'vant/lib/action-sheet/style';
export default {
    name: 'privacy-content-actionsheet',
    components: {
        VantActionSheet
    },
    props: {
        content: String,
        title: String,
    },
    data() {
        debugger
        return {
            showActionSheet: false
        }
    },
    methods: {
        openDialog() {
            this.showActionSheet = true;
        }
    }
};
</script>

<template>
    <vant-action-sheet v-model="showActionSheet" :title="title">
        <div class="content" v-html='content' />
    </vant-action-sheet>
</template>

<style scoped lang='less'>
.content {
    min-height: 50vh;
    font-size: 14px;
    padding: 24px;
    line-height: 1.5em;
}
</style>


// WEBPACK FOOTER //
// src/testdrive_components/form/privacy/privacy-content-actionsheet.vue